<div class="p-3 flex-row flex-wrap">
  <h3 mat-dialog-title class="w-100">{{title}}</h3>
  <mat-dialog-content class="w-100">
    <form [formGroup]="functionForm" class="w-100">
      <div class="w-100 flex-col justify-center items-stretch">
        <div class="m-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-select placeholder="Select Function" required formControlName="function" >
              @for (function of availableFunctions; track function) {
                <mat-option [value]="function">
                  {{function.name}}
                </mat-option>
              }
            </mat-select>
            @if (functionForm.controls.function.errors?.required) {
              <mat-error>Selection is required</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="m-3">
          <mat-form-field appearance="outline" class="w-100" >
            <mat-select placeholder="Select Path" required formControlName="nodePath" multiple >
              @for (nodePath of availableNodePaths; track nodePath) {
                <mat-option [value]="nodePath">
                  {{nodePath}}
                </mat-option>
              }
            </mat-select>
            @if (functionForm.controls.nodePath.errors?.required) {
              <mat-error>Selection is required</mat-error>
            }
          </mat-form-field>
        </div>
        @if (functionForm.controls.function.value?.resultType=='numeric') {
          <div class="m-3" >
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{functionForm.controls.function.value.formatLabel}}</mat-label>
              <input matInput formControlName="format" autocomplete="off">
              <mat-hint>{{functionForm.controls.function.value.formatHint}}</mat-hint>
            </mat-form-field>
          </div>
        }
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="w-100">
    <div class="mt-3 p-2 w-100 flex-row justify-end items-center">
      <a mat-button color="primary" class="dialog-btn mr-5" (click)="onCancelClick()"><span class="text-bold">{{cancelButtonText}}</span></a>
      <a mat-button color="primary" class="dialog-btn" [disabled]='!canConfirm' (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
    </div>
  </mat-dialog-actions>
</div>
